export interface NativeApp {
  getAnonymousUserId: () => string
}

declare const nativeApp: NativeApp

export const getNativeApp = (): NativeApp => {
  try {
    return nativeApp
  } catch (e) {
    return global.nativeApp
  }
}
